import { getConfigValue } from '@jutro/config';
import { createTSMRequest } from './tsmHelpers';
export const fetchTsmMessages = async (language, worksetUid, stringGroup, serverUrl = getConfigValue('JUTRO_TSM_SERVER'), stringVersion, jutroVersion) => {
  const url = `/api/v2/worksets/${worksetUid}/string-groups/${stringGroup}/strings-react/${language}`;
  const httpRequest = createTSMRequest(serverUrl).build();
  const parameters = {
    jutroVersion: jutroVersion || "5.3.1"
  };
  if (stringVersion) parameters.version = stringVersion;
  return (await httpRequest.get(url, parameters)).data;
};